<template>
  <div id="app">
    <el-container>
      <el-header>
        <page-header></page-header>
      </el-header>
      <el-main :class="{ 'modified-main': isPath != '/'}">
        <router-view />
      </el-main>
      <div class="footer">
        <page-footer></page-footer>
      </div>
    </el-container>
  </div>
</template>

<script>
import header from "@/components/Header.vue";
import footer from "@/components/Footer.vue";
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false,
    };
  },
  components: {
    pageHeader: header,
    pageFooter: footer,
  },
   computed: {
    isPath() {
      return this.$route.path;
    },
  },
  methods: {
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      window.console.log(this.isShow);
    },
  },
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  font-family: "PingFangSC", "PingFang SC", "Helvetica Neue", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.w {
  width: 1240px;
  margin: 0 auto;
}

.el-header {
  height: auto !important;
  padding: 0 !important;
}
.el-main {
  padding: 0 !important;
  min-height: 100vh !important;
}
.modified-main{
  background: #F2F2F2;
}

.footer {
  padding: 0 !important;
}
</style>
